<!-- <header class="row page-header">
    <div class="col-md-7">
        <h2 class="title">FINANCIALS</h2>
    </div>
    <div class="col-md-5 comm-state">
        <sp-comm-state [successMessage]="'Financials Saved Successfully'" [failedMessage]="'Financial Save failed'"
                       [scrollOnStateChange]="true" [scrollItemSelector] = "'body'"></sp-comm-state>
    </div>
</header> -->

<form *ngIf="propertyFinancialId" [formGroup]="formGroup" autocomplete="off">

    <!-- Fiscal Year -->
    <div class="form-section">
        <h3 class="section-header top-buffer-20">FISCAL YEAR</h3>

        <div class="row info align-items-end margin-top-20">
            <div class="col-md-3 col-sm-4">
                <div class="form-group">
                    <label>Fiscal Year</label>
                    <div>
                        <label>
                            {{ startFiscalYear | date: 'MMMM dd, yyyy'}} to {{ endFiscalYear | date: 'MMMM dd, yyyy'}}
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-4">
                <div class="form-group">
                    <label>What is the date your fiscal year begins?</label>&nbsp;<span class="red">*</span>
                    <div class="input-group">
                        <select class="sp-select form-control" formControlName="fiscalYearStartMonth" placeholder="Start Date" name="fiscalYearStartMonth" required >
                            <option *ngFor="let startDate of fiscalYearStartDates; let i = index" value="{{i+1}}">{{ startDate }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-4">
                <div class="form-group">
                    <label>{{ 'Assessment' | terminology | async }} Collection Frequency </label>&nbsp;<span class="red">*</span>
                    <div class="input-group">
                        <select class="sp-select form-control" formControlName="feeCollectionFrequencyId" placeholder="Frequency" name="feeCollectionFrequencyId" required>
                            <option *ngFor="let frequency of hoaFeeCollectionFrequencies; let i = index" value="{{frequency.id}}">{{ frequency.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Financial Assumptions -->
    <div class="form-section">
        <h3 class="section-header">FINANCIAL ASSUMPTIONS</h3>

        <div class="row info align-items-end margin-top-20">

            <!-- Previous Year Assessment Fee -->        
            <div class="col-md-3 col-sm-4" *ngIf="(workspaceSettings$ | async)?.featureToggleLoanAnalysis">
                <div class="form-group">
                    <label for="previousHoaAnnualFee">
                        {{ fiscalYear ? (fiscalYear - 1) : '' }} Annual {{ 'Assessment' | terminology | async }} Fees
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa fa-usd" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" formControlName="previousHoaAnnualFee" name="previousHoaAnnualFee"
                            id="previousHoaAnnualFee" [placeholder]="'Previous ' + (('Assessment' | terminology | async) || 'Assessment') + ' Fees'" maxlength="13" required spAutoNumeric #previousHoaAnnualFee />
                    </div>
                    <sp-field-error [controlName]="'Previous Assessment Fees'" [control]="formGroup.controls['previousHoaAnnualFee']"></sp-field-error>
                </div>
            </div>

            <!-- Current Year Assessment Fees -->
            <div class="col-md-3 col-sm-4">
                <div class="form-group">
                    <label for="averageHoaAnnualFee">
                        {{ fiscalYear ? fiscalYear : '' }} Annual {{ 'Assessment' | terminology | async }} Fees
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa fa-usd" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" formControlName="averageHoaAnnualFee" name="averageHoaAnnualFee"
                               id="averageHoaAnnualFee" [placeholder]="'Annual ' + (('Assessment' | terminology | async) || 'Assessment') + ' Fees'" maxlength="13" required spAutoNumeric #averageHoaAnnualFee />
                    </div>
                    <sp-field-error [controlName]="'Current Assessment Fees'" [control]="formGroup.controls['averageHoaAnnualFee']"></sp-field-error>
                </div>
            </div>
        </div>

        <div class="row info align-items-end margin-top-20">
            <!-- Starting Reserve Balance -->
            <div class="col-md-3 col-sm-4">
                <div class="form-group">
                    <label for="startingReserveBalance">
                        Reserve Balance on {{startFiscalYear | date: 'M/d/yyyy' }}
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa fa-usd" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" formControlName="startingReserveBalance" name="startingReserveBalance"
                               id="startingReserveBalance" placeholder="Starting Reserve Balance" maxlength="15" required spAutoNumeric #startingReserveBalance/>
                    </div>
                    <sp-field-error [controlName]="'Starting Reserve Balance'" [control]="formGroup.controls['startingReserveBalance']"></sp-field-error>
                </div>
            </div>
          
            <!-- Annual Reserve Contributions -->
            <div class="col-md-3 col-sm-4">
                <div class="form-group">
                    <label for="annualReserveContribution ">
                        {{ fiscalYear ? fiscalYear : '' }} Annual Reserve Contributions
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa fa-usd" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" formControlName="annualReserveContribution" name="annualReserveContribution"
                               id="annualReserveContribution " placeholder="Annual Reserve Contributions" maxlength="15" spAutoNumeric
                               required #annualReserveContribution />
                    </div>
                    <sp-field-error [controlName]="'Annual Reserve Contributions'" [control]="formGroup.controls['annualReserveContribution']"></sp-field-error>
                </div>
            </div>
        </div>

        <div class="row info align-items-end margin-top-20">
            <!-- Inflation Rate -->
            <div class="col-md-2 col-sm-4">
                <div class="form-group">
                    <label for="inflationRate">{{ 'Component' | terminology | async }} Inflation Rate</label>
                    <div class="input-group">
                        <input type="text" class="form-control" formControlName="inflationRate" name="inflationRate" #inflationRate
                               id="inflationRate" placeholder="Inflation %" maxlength="5" required spAutoNumeric />
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <i class="fa fa-percent" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                    <sp-field-error [controlName]="'Inflation Rate'" [control]="formGroup.controls['inflationRate']"></sp-field-error>
                </div>
            </div>

            <!-- Interest Rate -->
            <div class="col-md-2 col-sm-4 offset-md-1">
                <div class="form-group">
                    <label for="interestRate">Interest Rate on Reserve Funds</label>
                    <div class="input-group">
                        <input type="text" class="form-control" formControlName="interestRate" name="interestRate" #interestRate
                               id="interestRate" placeholder="Interest %" maxlength="5" spAutoNumeric required />
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <i class="fa fa-percent" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                    <sp-field-error [controlName]="'Interest Rate'" [control]="formGroup.controls['interestRate']"></sp-field-error>
                </div>
            </div>

            <!-- Rate of Annual Reserve Contribution Increases -->
            <div class="col-md-2 col-sm-4 offset-md-1">
                <div class="form-group">
                    <label for="reserveContributionIncreaseRate">Rate of Annual Reserve Contribution Increases</label>
                    <div class="input-group">
                        <input type="text" spAutoNumeric class="form-control" required formControlName="reserveContributionIncreaseRate"
                               name="reserveContributionIncreaseRate" #reserveContributionIncreaseRate placeholder="Reserve Contribution %"
                               id="reserveContributionIncreaseRate" maxlength="5" />
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <i class="fa fa-percent" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                    <sp-field-error [controlName]="'Rate of Annual Reserve Contribution Increases'" [control]="formGroup.controls['reserveContributionIncreaseRate']"></sp-field-error>
                </div>
            </div>
        </div>

        <div class="apply-existing-plans">
            <div class="row align-items-center">
                <div class="col-md-12">
                    <div class="message">
                        <strong>Do you wish to apply these assumptions to all of your existing {{fiscalYear}} plans?</strong>&nbsp;<span class="red">*</span>&nbsp;&nbsp;
                        <label class="btn-radio-container"><input type="radio" [value]="true" formControlName="updateAllPlans" #updateAllPlansTrue><span></span> Yes</label>
                        <label class="btn-radio-container"><input type="radio" [value]="false" formControlName="updateAllPlans" #updateAllPlansFalse><span></span> No</label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']">
        <div class="row info">
            <div class="col-md-12" *ngIf="!isPreviousFiscalYear">
                <a class="btn btn-default" [routerLink]="['useraccount/properties/dashboard']">CANCEL</a>
                <ng-container *ngIf="updateAllPlansTrue.checked">
                    <button [disabled]="!formGroup.valid || saving" type="submit" (click)="confirmSave.show()" class="btn btn-primary">
                        <span *ngIf="saving" class="sp-icon-loader-button-secondary u-alignMiddle"></span>{{saving? 'SAVING ...': 'SAVE'}}
                    </button>
                </ng-container>
                <ng-container *ngIf="updateAllPlansFalse.checked">
                    <button [disabled]="!formGroup.valid || saving" type="submit" (click)="onSave()" class="btn btn-primary">
                        <span *ngIf="saving" class="sp-icon-loader-button-secondary u-alignMiddle"></span>{{saving? 'SAVING ...': 'SAVE'}}
                    </button>
                </ng-container>
            </div>
        </div>

        <sp-modal #confirmSave title="UPDATE ALL PLANS" (confirm)="onSave()" confirmButtonText="Save">
            You have selected to apply your changes to all existing {{fiscalYear}} plans. The following {{fiscalYear}} plan financials will be updated to match what is on this scrreen:
            <ul *ngFor="let plan of plans$ | async" class="margin-top-10">
                <li class="font-weight-bold">{{plan.name}}
                    <span *ngIf="plan.planType == planType.Ladder" class="text-muted u-block font-italic">Individual ladder step contribution amounts & increase percentages will not be updated</span>
                </li>
            </ul>
        </sp-modal>
    </div>

</form>
